import Stack from "@mui/material/Stack"
import { DatePicker } from "@mui/x-date-pickers/DatePicker"
import DateRangeIcon from "@mui/icons-material/DateRange"
import React, { useEffect } from "react"
import Typography from "@mui/material/Typography"
import TextField from "@mui/material/TextField"
import {
  useGetDepartmentQuery,
  useGetLineQuery,
  useGetSelectQuery,
} from "../../../api/InterviewsApi"
import MenuItem from "@mui/material/MenuItem"
import { useForm } from "react-hook-form"
import dayjs, { Dayjs } from "dayjs"
import { ISelect } from "../../../model/shared/Selects"
import CircularProgress from "@mui/material/CircularProgress"

import useFormPersist from "react-hook-form-persist"
import {
  Alert,
  Autocomplete,
  Box,
  Button,
  LinearProgress,
  createFilterOptions,
} from "@mui/material"
import RestartAltIcon from "@mui/icons-material/RestartAlt"
import { useNavigate, useLocation } from "react-router-dom"
import queryString from "query-string"

const SearchFilters = ({
  handleClose,
  filledFieldsCount,
  setFilledFieldsCount,
  watch,
  onSubmit,
  reset,
  control,
  register,
  formState,
  handleSubmit,
  setValue,
  resetField,
  getFilledFieldsCount,
  updateFiltersInUrl,

  clearErrors,
}: any) => {
  const selects = useGetSelectQuery()

  const department = useGetDepartmentQuery(`${watch("project.id")}`, {
    skip: !watch("project.id"),
  })

  const line = useGetLineQuery(watch("department.id"), {
    skip: !watch("department.id"),
  })

  if (line.error || department.error || selects.error) {
    return <Alert severity="error"> Произошла ошибка</Alert>
  }

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault()
        handleSubmit(onSubmit)()
      }}
    >
      <Stack direction={"column"} spacing={"10px"}>
        <Stack direction={"row"} spacing={"40px"}>
          <Stack direction={"column"} spacing={"5px"} sx={{ width: "480px" }}>
            <Stack direction={"column"} spacing={"5px"}>
              <Typography sx={{ fontSize: 14, fontWeight: "bold" }}>
                Собеседующий
              </Typography>
              <Autocomplete
                isOptionEqualToValue={(option, value) => option.id === value.id}
                value={watch("interviewer")}
                loading={selects.isLoading}
                {...register("interviewer")}
                size="small"
                getOptionKey={(option) => option.id}
                fullWidth
                onChange={(event: any, value: any) => {
                  setValue("interviewer", value)
                }}
                options={selects?.data.filterOptions?.interviewer}
                getOptionLabel={(option) => option.name}
                renderInput={(params) => (
                  <TextField
                    variant="outlined"
                    {...params}
                    placeholder="Собеседующий"
                  />
                )}
              />
            </Stack>
            <Stack direction={"column"} spacing={"5px"}>
              <Typography sx={{ fontSize: 14, fontWeight: "bold" }}>
                Рекрутёр масснайма
              </Typography>
              <Autocomplete
                isOptionEqualToValue={(option, value) => option.id === value.id}
                value={watch("massRecruiter")}
                loading={selects.isLoading}
                {...register("massRecruiter")}
                size="small"
                getOptionKey={(option) => option.id}
                fullWidth
                onChange={(event: any, value: any) => {
                  setValue("massRecruiter", value)
                }}
                options={selects?.data.filterOptions?.massRecruiter}
                getOptionLabel={(option) => option.name}
                renderInput={(params) => (
                  <TextField
                    variant="outlined"
                    {...params}
                    placeholder="Рекрутер масснайма"
                  />
                )}
              />
            </Stack>
            <Stack direction={"column"} spacing={"5px"}>
              <Typography sx={{ fontSize: 14, fontWeight: "bold" }}>
                Специалист обучения
              </Typography>

              <Autocomplete
                isOptionEqualToValue={(option, value) => option.id === value.id}
                value={watch("training")}
                loading={selects.isLoading}
                {...register("training")}
                size="small"
                getOptionKey={(option) => option.id}
                fullWidth
                onChange={(event: any, value: any) => {
                  setValue("training", value)
                }}
                options={selects?.data.filterOptions?.training}
                getOptionLabel={(option) => option.name}
                renderInput={(params) => (
                  <TextField
                    variant="outlined"
                    {...params}
                    placeholder="Рекрутер масснайма"
                  />
                )}
              />
            </Stack>
          </Stack>

          <Stack direction={"column"} spacing={"5px"} sx={{ width: "466px" }}>
            <Stack direction={"column"} spacing={"5px"}>
              <Typography sx={{ fontSize: 14, fontWeight: "bold" }}>
                Проект
              </Typography>

              {selects.data && (
                <Autocomplete
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                  value={watch("project")}
                  loading={selects.isLoading}
                  {...register("project")}
                  size="small"
                  getOptionKey={(option) => option.id}
                  fullWidth
                  onChange={(event: any, value: any) => {
                    setValue("project", value)
                    resetField("department")
                    resetField("line")
                  }}
                  options={selects?.data.filterOptions?.project}
                  getOptionLabel={(option) => option.name}
                  renderInput={(params) => (
                    <TextField
                      variant="outlined"
                      {...params}
                      placeholder="Проект"
                    />
                  )}
                />
              )}
            </Stack>
            <Stack direction={"column"} spacing={"5px"}>
              <Typography sx={{ fontSize: 14, fontWeight: "bold" }}>
                Направление
              </Typography>

              <Autocomplete
                disabled={watch("project.id") ? false : true}
                loading={department?.isLoading}
                value={watch("department")}
                {...register("department")}
                size="small"
                getOptionKey={(option) => option.id}
                fullWidth
                onChange={(event: any, value: any) => {
                  setValue("department", value)
                  resetField("line")
                }}
                options={department?.data || []}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                getOptionLabel={(option) => option.name}
                renderInput={(params) => (
                  <TextField
                    variant="outlined"
                    {...params}
                    placeholder="Направление"
                  />
                )}
              />
            </Stack>
            <Stack direction={"column"} spacing={"5px"}>
              <Typography sx={{ fontSize: 14, fontWeight: "bold" }}>
                Линия
              </Typography>
              <Autocomplete
                isOptionEqualToValue={(option, value) => option.id === value.id}
                disabled={watch("department.id") ? false : true}
                value={watch("line")}
                {...register("line")}
                size="small"
                getOptionKey={(option) => option.id}
                fullWidth
                onChange={(event: any, value: any) => {
                  setValue("line", value)
                }}
                options={line?.data?.data || []}
                getOptionLabel={(option) => option.name}
                renderInput={(params) => (
                  <TextField
                    variant="outlined"
                    {...params}
                    placeholder="Линия"
                  />
                )}
              />
            </Stack>
            <Stack direction={"column"} spacing={"5px"}>
              <Typography sx={{ fontSize: 14, fontWeight: "bold" }}>
                Тип графика
              </Typography>
              <Autocomplete
                isOptionEqualToValue={(option, value) => option.id === value.id}
                value={watch("graphType")}
                {...register("graphType")}
                size="small"
                getOptionKey={(option) => option.id}
                fullWidth
                onChange={(event: any, value: any) => {
                  setValue("graphType", value)
                }}
                options={selects.data?.filterOptions?.graphType || []}
                getOptionLabel={(option) => option.name}
                renderInput={(params) => (
                  <TextField
                    variant="outlined"
                    {...params}
                    placeholder="Тип графика"
                  />
                )}
              />
            </Stack>
            <Stack direction={"column"} spacing={"5px"}>
              <Typography sx={{ fontSize: 14, fontWeight: "bold" }}>
                Статус
              </Typography>
              <Autocomplete
                isOptionEqualToValue={(option, value) => option.id === value.id}
                value={watch("status")}
                {...register("status")}
                size="small"
                getOptionKey={(option) => option.id}
                fullWidth
                onChange={(event: any, value: any) => {
                  setValue("status", value)
                }}
                options={selects.data?.filterOptions?.status || []}
                getOptionLabel={(option) => option.name}
                renderInput={(params) => (
                  <TextField
                    variant="outlined"
                    {...params}
                    placeholder="Статус"
                  />
                )}
              />
            </Stack>
            <Stack direction={"column"} spacing={"5px"}>
              <Typography sx={{ fontSize: 14, fontWeight: "bold" }}>
                Дата собеседования
              </Typography>

              <Stack
                alignItems={"center"}
                justifyContent={"center"}
                direction={"row"}
                spacing={"5px"}
              >
                <DatePicker
                  slots={{
                    openPickerIcon: DateRangeIcon,
                  }}
                  sx={{
                    ".MuiIconButton-root": {
                      color: "rgba(139, 139, 139, 1)",
                    },
                    ".MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline":
                      {
                        borderColor: "rgba(0, 0, 0, 0.23)",
                      },
                    ".MuiFormHelperText-root.Mui-error": {
                      color: "rgba(0, 0, 0, 0.6)",
                    },
                  }}
                  value={dayjs(watch("startDate")) || null}
                  localeText={{
                    toolbarTitle: "ЧЧ.ММ.ГГГГ",
                    fieldDayPlaceholder: () => "ДД",
                    fieldMonthPlaceholder: () => "ММ",
                    fieldYearPlaceholder: () => "ГГГГ",
                  }}
                  onChange={(e: Dayjs | null) => {
                    dayjs(e).isValid() &&
                      setValue(
                        "startDate",
                        dayjs(e).format("YYYY-MM-DDTHH:mm:ss"),
                      )
                  }}
                  format="DD.MM.YYYY"
                  slotProps={{
                    textField: {
                      inputProps: register("startDate"),
                      size: "small",
                      variant: "outlined",
                      placeholder: "ДД.ММ.ГГГГ",
                      fullWidth: true,
                    },
                  }}
                />
                <div
                  style={{
                    width: "10px",
                    height: "1px",
                    background: "#CACACA",
                    borderRadius: 4,
                  }}
                />
                <DatePicker
                  slots={{
                    openPickerIcon: DateRangeIcon,
                  }}
                  sx={{
                    ".MuiIconButton-root": {
                      color: "rgba(139, 139, 139, 1)",
                    },
                    ".MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline":
                      {
                        borderColor: "rgba(0, 0, 0, 0.23)",
                      },
                    ".MuiFormHelperText-root.Mui-error": {
                      color: "rgba(0, 0, 0, 0.6)",
                    },
                  }}
                  value={dayjs(watch("endDate")) || null}
                  localeText={{
                    toolbarTitle: "ЧЧ.ММ.ГГГГ",
                    fieldDayPlaceholder: () => "ДД",
                    fieldMonthPlaceholder: () => "ММ",
                    fieldYearPlaceholder: () => "ГГГГ",
                  }}
                  onChange={(e: Dayjs | null) => {
                    dayjs(e).isValid() &&
                      setValue(
                        "endDate",
                        dayjs(e).format("YYYY-MM-DDTHH:mm:ss"),
                      )
                  }}
                  format="DD.MM.YYYY"
                  slotProps={{
                    textField: {
                      inputProps: register("endDate"),
                      size: "small",
                      variant: "outlined",
                      placeholder: "ДД.ММ.ГГГГ",
                      fullWidth: true,
                    },
                  }}
                />
              </Stack>
            </Stack>
          </Stack>
        </Stack>
        <Stack justifyContent={"space-between"} direction="row">
          <Button
            disabled={filledFieldsCount === 0}
            onClick={() => {
              reset()
              updateFiltersInUrl({})
            }}
            size="large"
            variant="text"
            startIcon={<RestartAltIcon />}
          >
            Сбросить фильтры
          </Button>
          <Stack direction="row" spacing="10px">
            {/* <Button
              onClick={handleClose}
              size="large"
              sx={{ fontWeight: "bold" }}
              variant="outlined"
            >
              Отмена
            </Button> */}

            <Button
              size="large"
              sx={{ fontWeight: "bold" }}
              variant="contained"
              type="submit"
              onClick={handleClose}
            >
              Закрыть
            </Button>
          </Stack>
        </Stack>
      </Stack>
    </form>
  )
}

export default SearchFilters
